import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import withModules from 'cccisd-laravel-assignment/dist/components/navigations/withModules';

const navigations = [courseWrapper, withModules];

export default navigations;
